import "./App.css";
import { Routing } from "./components/router/Routing";

function App() {
  return (
    <div className="App">
      <div className="App-header">
        <Routing />
      </div>
    </div>
  );
}

export default App;
